import React from 'react';

const SecondaryButton = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  className = '',
  ...rest
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    className={`h-[34px] px-[13px] bg-surface hover:bg-line/60 text-brand-600 rounded-lg text-xs font-medium flex items-center justify-center gap-1.5 transition-colors disabled:text-ink-disabled disabled:cursor-not-allowed focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus ${className}`}
    {...rest}
  >
    {loading && (
      <span className="animate-spin h-3.5 w-3.5 border-2 border-current border-t-transparent rounded-full shrink-0" />
    )}
    {children}
  </button>
);

export default SecondaryButton;
